import { NavLink, Outlet, Link } from "react-router-dom";
import RequireAuth from "../../auth/RequireAuth";
import RequireConsent from "../../auth/RequireConsent";
import RequirePermission from "../../auth/RequirePermission";

const PARTNER_TABS = [
  { to: "/partner/dashboard", label: "Dashboard" },
  { to: "/partner/listings", label: "Listings" },
  { to: "/partner/sources", label: "Sources" },
];

const PartnerLayoutContent = () => (
  <div className="midpoint-app auth-page account-area-app partner-portal-app">
    <div className="account-area-layout">
      <header className="account-security-header panel-card">
        <p className="eyebrow">Partner</p>
        <h1>Partner portal</h1>
        <p className="muted">View listings and sources for your assigned organizations.</p>
        <nav className="account-area-tabs" aria-label="Partner sections">
          {PARTNER_TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                `account-area-tabs__link${isActive ? " is-active" : ""}`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
        <p className="muted account-security-nav">
          <Link to="/">Back to map</Link>
        </p>
      </header>
      <Outlet />
    </div>
  </div>
);

const PartnerLayout = () => (
  <RequireAuth>
    <RequireConsent>
      <RequirePermission permission="partner_dashboard.view">
        <PartnerLayoutContent />
      </RequirePermission>
    </RequireConsent>
  </RequireAuth>
);

export default PartnerLayout;
